import React from "react";

export const List = (
    <g>
        <path d="M4,0v48h40V0H4z M12,1c0.553,0,1,0.447,1,1s-0.447,1-1,1s-1-0.447-1-1S11.447,1,12,1z M9,1c0.553,0,1,0.447,1,1   S9.553,3,9,3S8,2.553,8,2S8.447,1,9,1z M6,1c0.553,0,1,0.447,1,1S6.553,3,6,3S5,2.553,5,2S5.447,1,6,1z M43,47H13v-6.051   c1.142-0.232,2-1.24,2-2.449c0-1.21-0.858-2.219-2-2.45v-4.101c1.142-0.232,2-1.24,2-2.449c0-1.21-0.858-2.219-2-2.45v-4.1   c1.142-0.232,2-1.24,2-2.45s-0.858-2.218-2-2.45v-4.101c1.142-0.232,2-1.24,2-2.45c0-1.381-1.119-2.5-2.5-2.5S10,10.119,10,11.5   c0,1.209,0.858,2.218,2,2.45v4.101c-1.142,0.232-2,1.24-2,2.45s0.858,2.218,2,2.45v4.1c-1.142,0.231-2,1.24-2,2.45   c0,1.209,0.858,2.217,2,2.449v4.101c-1.142,0.231-2,1.24-2,2.45c0,1.209,0.858,2.217,2,2.449V47H5V4h38V47z" />
        <rect x="17" y="9" width="10" height="2" />
        <rect x="17" y="14" width="20" height="1" />
        <rect x="17" y="12" width="18" height="1" />
        <rect x="17" y="18" width="10" height="2" />
        <rect x="17" y="23" width="20" height="1" />
        <rect x="17" y="21" width="18" height="1" />
        <rect x="17" y="27" width="10" height="2" />
        <rect x="17" y="32" width="20" height="1" />
        <rect x="17" y="30" width="18" height="1" />
        <rect x="17" y="36" width="10" height="2" />
        <rect x="17" y="41" width="20" height="1" />
        <rect x="17" y="39" width="18" height="1" />
    </g>
);
